import * as Common from '@/tenantCatalog/common';

export class Pricing extends Common.StateObject{
  constructor(){
    super('Pricing');
    this.state = Common.ApprovalStatus.NotApproved;  
    this.workflowStateId = Common.ApprovalStatus.NotApproved;  
  }
  public licenseFlag : number;
  public isPrime: boolean;
  public description : string = '';
  public basePrice : number;
  public licensePrice : number;
  public storagePrice :number;
}

export class PricingQuery extends Common.LoadQuery {
  constructor(){
    super('PricingQuery',Pricing);
    this.sort = 'licenseFlag';    
  }

}